class CannedResponseTitle {
  constructor(title, id, text) {
    this.title = title;
    this.id = id;
    this.text = text;
  }
}

export default CannedResponseTitle;
